export default "<app-bandwidth-tab >\r\n</app-bandwidth-tab>\r\n";